// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo__1M8pS","logoAlt":"logoAlt__1R86U"};